"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentType = void 0;
var contentType_1 = require("./contentType");
Object.defineProperty(exports, "getContentType", { enumerable: true, get: function () { return contentType_1.getContentType; } });
